import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bank: {
    defaultMessage: 'Bank',
    id: 'DetailedAccountInformation.bank',
  },
  iban: {
    defaultMessage: 'IBAN',
    id: 'DetailedAccountInformation.iban',
  },
  holderName: {
    defaultMessage: 'Holder name',
    id: 'DetailedAccountInformation.holderName',
  },
});
